import { gql } from "@apollo/client";

// People for the Career Tracks "Viewing:" picker, searched on the server: an
// organization can be far bigger than the picker should load at once.
export default gql`
  query getCareerTrackPickerPeople($organizationId: Int!, $search: String!) {
    organization(pk: $organizationId) {
      id
      members(first: 20, search: $search, orderBy: "name") {
        edges {
          node {
            id
            user {
              id
              name
              avatar
            }
          }
        }
      }
    }
  }
`;
